document.addEventListener("DOMContentLoaded", function (event) {
    handleFilterTagClick();
});

function handleFilterTagClick() {
    const filterTags = document.querySelectorAll('.tag-filter-item');
    if (filterTags.length > 0) {
        filterTags.forEach(tag => {
            tag.addEventListener('click', () => {
                const tagInput = tag.querySelector('[data-filter-tag]');
                tagInput.click();
            });
        });
    }
}
